import { Code } from '@mantine/core'
import { getTaskArgsEntry } from './args-registry'

/** A run's recorded args: the task's registered component (read-only) or a JSON block. */
export function TaskArgsView({ slug, value }: { slug: string; value: unknown }) {
  const entry = getTaskArgsEntry(slug)
  if (entry) return <entry.Component value={value} readOnly />
  if (value == null) return <>—</>
  return <Code block>{JSON.stringify(value, null, 2)}</Code>
}
